import { ActionIcon, Group, Menu } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { Handle, Position, useReactFlow } from "reactflow";
import { defaultNodeConfigs, isMainAction, nodeWidth } from "../flowSettings";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { handleLayout } from "../layouter";
import { useState } from "react";
import ActionsList from "../components/ActionsList";
import { getInheritedCredentials } from "../flowUtils";

const TrailNode = ({ data, xPos, yPos }) => {
  const reactFlow = useReactFlow();
  const linking = useFlowStore((s) => s.linking);
  const [opened, setOpened] = useState(false);
  const getId = useFlowStore((s) => s.getId);
  const nodes = useFlowStore((s) => s.nodes);
  const setNodes = useFlowStore((s) => s.setNodes);
  const edges = useFlowStore((s) => s.edges);
  const setEdges = useFlowStore((s) => s.setEdges);
  const initialId = useFlowStore((s) => s.initialId);

  const handleAdd = (actionType) => {
    let newNodes = [...nodes];
    let newEdges = [...edges];
    let newNodeId = getId().toString();
    let newEventNodeId = data?.source;

    let autoData = { ...defaultNodeConfigs };
    const inheritedCreds = getInheritedCredentials(nodes, data?.source, actionType);

    if (inheritedCreds) {
      autoData.integration_id = inheritedCreds.integration_id;
      autoData.pool_id = inheritedCreds.pool_id;
      autoData.signature_id = inheritedCreds.signature_id;
    }
    //#endregion

    // Add Event node if source is not initial
    if (data?.source !== initialId && data?.shouldBeEvent) {
      newEventNodeId = getId().toString();
      const newEventNode = {
        id: newEventNodeId,
        type: "action",
        data: {
          actionType: "event",
          source: data?.source,
          event_type: data?.fromCall ? "call_custom" : undefined,
          error: data?.error,
        },
        position: { x: xPos, y: yPos },
      };
      newNodes.push(newEventNode);

      const newEventEdge = {
        id: `e-${data?.source}-${newEventNodeId}`,
        source: data?.source,
        target: newEventNodeId,
        data: { fromEvent: false, error: data?.error },
      };
      newEdges.push(newEventEdge);
    }

    const newNode = {
      id: newNodeId,
      type: "action",
      data: {
        actionType: actionType,
        source: data?.source === initialId ? initialId : newEventNodeId,
        ...autoData,
        sending_weekends_allowed: data?.source === initialId ? true : false,
        error: data?.error,
        event_type:
          data?.source === initialId && actionType === "event"
            ? "all_contacts"
            : undefined,
        when_minutes:
          data?.source === initialId && actionType === "event"
            ? 1
            : defaultNodeConfigs.when_minutes,
      },
      position: { x: xPos, y: yPos },
    };
    newNodes.push(newNode);

    if (data?.source === initialId || !data?.shouldBeEvent) {
      const newEdge = {
        id: `e-${data?.source}-${newNodeId}`,
        source: data?.source,
        target: newNodeId,
        data: { fromEvent: true, error: data?.error },
      };
      newEdges.push(newEdge);
    } else {
      const newEdge = {
        id: `e-${newEventNodeId}-${newNodeId}`,
        source: newEventNodeId,
        target: newNodeId,
        data: { fromEvent: true, error: data?.error },
      };
      newEdges.push(newEdge);
    }

    setNodes(newNodes.filter((x) => x.id !== `${data.source}-trail`));
    setEdges(newEdges.filter((x) => x.id !== `e-${data.source}-trail`));

    setTimeout(() => {
      handleLayout();
      setTimeout(() => {
        let nodes = useFlowStore.getState().nodes;
        let n = nodes.find((x) => x.id === newNodeId);
        // let n_trail = nodes.find((x) => x.id === newNodeId + "-trail");
        let e_n = nodes.find((x) => x.id === newEventNodeId);
        const setSelectedNode = useFlowStore.getState().setSelectedNode;
        if (isMainAction(n)) {
          setSelectedNode(n);

          return setTimeout(() => {
            reactFlow?.setCenter(
              n.x + 128,
              data?.source === initialId ? 312 : n.y + (e_n ? 0 : 132),
              {
                duration: 200,
                zoom: 1,
              }
            );
          }, 300);
        }
        reactFlow?.setCenter(n.x + 128, n.y + (e_n ? 0 : 132), {
          duration: 1000,
          zoom: 1,
        });
      }, 500);
    }, 200);
  };

  return (
    <>
      <Handle
        type="target"
        position={useFlowStore.getState().layout === "horizontal" ? Position.Left : Position.Top}
        style={{ visibility: "hidden" }}
      />

      <Group w={nodeWidth} justify="center">
        <Menu
          trigger="click-hover"
          openDelay={200}
          closeDelay={200}
          position={data?.source === initialId ? "bottom" : "right"}
          onChange={setOpened}
          shadow="md"
          width={235}
          zIndex={200}
        >
          <Menu.Target>
            <ActionIcon
              radius={"lg"}
              variant="white"
              style={{ boxShadow: "#00000033 0 1px 3px", border: "none" }}
              disabled={linking}
              className={
                data?.source === initialId && !opened
                  ? "animate__animated animate__heartBeat animate__infinite"
                  : null
              }
            >
              <IconPlus
                size={18}
                style={{
                  transform: opened ? "rotate(135deg)" : "none",
                  transition: "all ease .15s",
                }}
              />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <ActionsList
              handleActionClick={handleAdd}
              noSecondary={data?.source === initialId}
              withEvent={data?.source === initialId}
            />
          </Menu.Dropdown>
        </Menu>
      </Group>
    </>
  );
};

export default TrailNode;
